(() => {
const slider = document.querySelector(".upment-bannerslider");
let slides = Array.from(slider.querySelectorAll(".slide"));
if (slides.length === 0) return;

  const delay = parseFloat(slider.dataset.delay) * 1000 || 4000;
  const animation = slider.dataset.animation;

  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);
  const firstSlideImg = slides[1].querySelector("img");

  firstClone.classList.add("slide-clone");
  lastClone.classList.add("slide-clone");

  slider.appendChild(firstClone);
  slider.insertBefore(lastClone, slides[0]);

  slides = Array.from(slider.querySelectorAll(".slide"));

  let index = 1;

  slides.forEach((slide, i) => {
    if (i === index) return;
    const img = slide.querySelector("img[style]");
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) {
      img.removeAttribute("style");
    } else {
      img.addEventListener(
        "load",
        () => {
          img.removeAttribute("style");
        },
        { once: true },
      );
      img.addEventListener(
        "error",
        () => {
          img.removeAttribute("style");
        },
        { once: true },
      );
    }
  });

  function setSliderHeight() {
    if (firstSlideImg.complete) {
      slider.style.height = firstSlideImg.offsetHeight + "px";
    } else {
      firstSlideImg.addEventListener("load", () => {
        slider.style.height = firstSlideImg.offsetHeight + "px";
      });
    }
  }

  // setSliderHeight();

  if (animation != "fade-banner") {
    slides.forEach((slide, i) => {
      slide.style.transform = `translateX(${(i - index) * 100}%)`;
    });
  }

  firstClone.classList.remove("slide-clone");
  lastClone.classList.remove("slide-clone");

  function moveSlides() {
    slides.forEach((slide, i) => {
      slide.style.transition = "all 3s ease-in-out";
      slide.style.transform = `translateX(${(i - index) * 100}%)`;
    });
  }

  function resetWithoutAnimation() {
    slides.forEach((slide, i) => {
      slide.style.transition = "none";
      slide.style.transform = `translateX(${(i - index) * 100}%)`;
    });
  }

  setInterval(() => {
    if (animation === "fade-banner") {
      slides.forEach((slide, i) => {
        slide.style.opacity = 0;
        slide.style.zIndex = 1;
        slide.style.transition = "all 3s ease-in-out";
      });

      slides[index].style.opacity = 1;
      slides[index].style.zIndex = 2;

      index++;
      if (index >= slides.length - 1) index = 1;

      return;
    }

    if (animation === "leftslide-banner") {
      index++;
      moveSlides();

      if (index === slides.length - 1) {
        setTimeout(() => {
          index = 1;
          resetWithoutAnimation();
        }, 3000);
      }
    }

    if (animation === "rightslide-banner") {
      index--;
      moveSlides();

      if (index === 0) {
        setTimeout(() => {
          index = slides.length - 2;
          resetWithoutAnimation();
        }, 3000);
      }
    }
}, delay);
})();
